import React from "react";
import { ARIAKE, IMG, SITE } from "../lib/data";
import { AriakeMark } from "./AriakeLogo";

const waLink = `https://wa.me/${SITE.whatsappIntl}?text=${encodeURIComponent(
  "Hola, quiero conocer más sobre Ariake."
)}`;

export default function AriakeShowcase() {
  return (
    <section
      id="ariake"
      data-testid="ariake-showcase"
      className="relative bg-black text-white py-20 md:py-28 lg:py-32 overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute -top-40 left-1/2 -translate-x-1/2 h-[500px] md:h-[600px] w-[900px] md:w-[1200px] rounded-full opacity-25 blur-3xl pointer-events-none"
        style={{ background: "radial-gradient(closest-side, hsl(35, 58%, 60%), transparent 70%)" }}
      />

      <div className="container-hh relative">
        <div className="flex items-center gap-3 sm:gap-4 reveal">
          <AriakeMark className="h-6 w-6 md:h-7 md:w-7" color="hsl(35, 58%, 60%)" />
          <span className="overline text-white/60" style={{ fontSize: "0.62rem" }}>
            Proyecto destacado
          </span>
        </div>

        <div className="grid grid-cols-12 gap-x-4 gap-y-10 md:gap-12 mt-8 md:mt-10 items-start">
          <div className="col-span-12 lg:col-span-6 reveal">
            <h2 className="font-display text-6xl sm:text-7xl md:text-8xl leading-[0.92] tracking-tight">
              ARIAKE
            </h2>
            <p
              className="font-display text-xl sm:text-2xl md:text-3xl mt-3 italic"
              style={{ color: "hsl(var(--hh-sunrise))" }}
            >
              Tu hogar, un nuevo amanecer.
            </p>
            <div className="hairline my-8 bg-white" />
            <p className="max-w-xl text-white/75 text-sm md:text-lg leading-relaxed">
              Casas independientes de una sola planta en Tumbaco — sector Hilacril.
              Inspiradas en el amanecer japonés y diseñadas para una vida equilibrada,
              conectada con la naturaleza.
            </p>

            <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4">
              {ARIAKE.highlights.map((h, i) => (
                <div key={i} className="border-l border-white/15 pl-3">
                  <div className="font-display text-2xl">
                    {h.kpi}
                    <span className="text-white/40 text-sm ml-1">{h.unit}</span>
                  </div>
                  <div className="overline mt-1 text-white/50" style={{ fontSize: "0.55rem" }}>
                    {h.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-8 md:mt-10 flex flex-wrap gap-2 sm:gap-3">
              <a href="#contacto" className="btn-hh btn-hh-sunrise" data-testid="ariake-cta-info">
                Más información
              </a>
              <a
                href={SITE.brochureUrl}
                download
                className="btn-hh btn-hh-ghost"
                data-testid="ariake-cta-brochure"
              >
                Brochure
              </a>
              <a
                href={waLink}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-hh btn-hh-ghost"
                data-testid="ariake-cta-whatsapp"
              >
                WhatsApp
              </a>
            </div>
          </div>

          <div className="col-span-12 lg:col-span-6 reveal">
            <div className="relative aspect-[4/3] overflow-hidden">
              <img
                src={IMG.ariake.entranceClean}
                alt="Ariake — vista exterior del proyecto"
                className="absolute inset-0 h-full w-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
